import { Check } from '../Check';

const mapIconToSymbol = {
  Checkmark: (
    <span className="bg-cipher-02 rounded-full flex items-center justify-center size-22">
      <Check className="w-14 h-10 text-charcoal" />
    </span>
  ),
  Dash: (
    <svg
      width="23"
      height="23"
      viewBox="0 0 23 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="stroke-charcoal"
        d="M3.49023 11.7007H18.9793"
        strokeWidth="1.36937"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
};

export const CellIcon = ({
  className,
  icon,
}: {
  className?: string;
  icon?: null | keyof typeof mapIconToSymbol;
}) => {
  if (!icon) return null;
  return <span className={className}>{mapIconToSymbol[icon]}</span>;
};
